"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var FinanceReconciliationEditor = /** @class */ (function (_super) {
    __extends(FinanceReconciliationEditor, _super);
    function FinanceReconciliationEditor(props) {
        return _super.call(this, props) || this;
    }
    FinanceReconciliationEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    pprogram_id: _item.pprogram_id,
                    pprogram_title: _item.pprogram_title,
                    is_reset_negative_balances: _item.is_reset_negative_balances,
                    description: _item.description,
                    title: _item.title,
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование сверки"]);
                });
            }
        }
        else {
            this.setState({
                brand_id: 0,
                brand_title: "",
                pprogram_id: 0,
                pprogram_title: "",
                is_reset_negative_balances: false,
                description: "",
                title: "",
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание сверки"]);
            });
        }
        this.doReSetRules();
    };
    FinanceReconciliationEditor.prototype.doReSetRules = function () {
        this.setState({
            brand_rules: { isError: false },
            pprogram_rules: { isError: false },
            title_rules: { isError: false }
        });
    };
    FinanceReconciliationEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({ brand_rules: { isError: true, errorMessage: "Поле [брэнд] не выбрано!" } });
            return false;
        }
        if ((this.state.pprogram_id <= 0) || (this.state.pprogram_title.length === 0)) {
            this.setState({ pprogram_rules: { isError: true, errorMessage: "Поле [п.программа] не выбрано!" } });
            return false;
        }
        if (this.state.title.length == 0) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено, или заполнено некорректно!" } });
            return false;
        }
        return true;
    };
    FinanceReconciliationEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                description: this.state.description,
                title: this.state.title,
                is_reset_negative_balances: this.state.is_reset_negative_balances
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Сверка изменена!");
            });
        }
    };
    FinanceReconciliationEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                description: this.state.description,
                title: this.state.title,
                brand_id: this.state.brand_id,
                is_reset_negative_balances: this.state.is_reset_negative_balances,
                pprogram_id: this.state.pprogram_id,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Сверка добавлена!");
            });
        }
    };
    FinanceReconciliationEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    FinanceReconciliationEditor.prototype.getFormTitle = function () {
        if (this.props.record == null) {
            return "Добавить сверку";
        }
        else {
            return "Изменить сверку";
        }
    };
    FinanceReconciliationEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 450 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    });
                }, items: this.props.availBrands, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "П.Программа:", placeholder: "Выберите партнерскую программу" }, value: { key: this.state.pprogram_id, value: this.state.pprogram_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        pprogram_id: newVal.key,
                        pprogram_title: newVal.value,
                        pprogram_rules: { isError: false }
                    });
                }, items: this.props.availPPrograms, disabled: this.props.record != null, required: true, rules: this.state.pprogram_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Сбрасывать отрицательные остатки", value: this.state.is_reset_negative_balances, onChecked: function (checked) {
                    _this.setState({
                        is_reset_negative_balances: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return FinanceReconciliationEditor;
}(React.Component));
exports.default = FinanceReconciliationEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_reconciliations/ui/component/FinanceReconciliationEditor.tsx
// module id = 2555
// module chunks = 0